import { AnimationProperties, AnimationsKit } from '../../../types';

const name = 'BaseSequence';
const properties: Partial<AnimationProperties> = {};

function animate(kit: AnimationsKit, params: any) {
  return kit.engine.timeline(params, []);
}

export { name, properties, animate };
